import { PageHeader } from 'antd'
import React from 'react'
import JcpReceiptList from '../../components/enrollment/jcp/JcpReceiptList'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'

const JcpEnrollmentReceiptList = () => {
  return (
<div>
<div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="JCP Enrollment List "
          subTitle=""
          
        ></PageHeader>

       
        <div className='tableView'>
        <div className="form-content">

      

            <JcpReceiptList />
        </div>
        </div>

      </div>
    </div>

    </div>







  )
}

export default JcpEnrollmentReceiptList